<p class="mt-0">{{ info.description }}</p>

<p-message
  *ngIf="info.irreversible"
  severity="warn"
  styleClass="w-full mb-3"
  text="L'operazione non si annulla dall'applicazione: dalla lista RAEE l'asset esce solo con lo smaltimento."></p-message>

<div class="mb-3">
  <span class="font-bold">{{
    assets.length === 1 ? 'Asset' : 'Asset (' + assets.length + ')'
  }}</span>
  <ul class="special-move-assets mt-2">
    <li *ngFor="let a of assets">
      <span class="font-bold">{{ a.serial_number }}</span>
      <span
        *ngIf="a.related_product?.name"
        class="ml-2"
        >{{ a.related_product?.name }}</span
      >
      <small class="block text-color-secondary">{{ positionLabel(a) }}</small>
    </li>
  </ul>
</div>

<div
  *ngIf="askDestination"
  class="mb-3">
  <label class="block mb-2">Magazzino di destinazione (facoltativo)</label>
  <app-input-office-picker [frmControl]="destination"></app-input-office-picker>
  <small class="block mt-1 text-color-secondary"
    >Se non indicato, l'asset torna nel magazzino a cui appartiene la sede di sistema.</small
  >
</div>

<div class="mb-3">
  <label
    for="special-move-notes"
    class="block mb-2"
    >Note (facoltative)</label
  >
  <textarea
    id="special-move-notes"
    [formControl]="notes"
    rows="3"
    class="w-full text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary"></textarea>
</div>

<div
  *ngIf="info.irreversible"
  class="flex align-items-center gap-2 mb-3">
  <p-checkbox
    [formControl]="acknowledged"
    [binary]="true"
    inputId="special-move-ack"></p-checkbox>
  <label for="special-move-ack">Ho capito: l'asset resterà in RAEE fino allo smaltimento</label>
</div>

<p-message
  *ngIf="errorMessage"
  severity="error"
  styleClass="w-full mb-3"
  [text]="errorMessage"></p-message>

<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      (onClick)="close()"
      label="Annulla"
      [text]="true"
      styleClass="butt red"
      [rounded]="true"
      [disabled]="isLoading"></p-button>
    <p-button
      [label]="info.label"
      (onClick)="submit()"
      styleClass="butt"
      [rounded]="true"
      [loading]="isLoading"
      [disabled]="!canSubmit"></p-button>
  </div>
</div>
